export default __webpack_public_path__ + "static/media/weight.3bda9bb9.png";